// INMA-320: Badge de plan de suscripción para sidebar/header
import { Link } from "react-router";
import { Zap, Star, Building2, CreditCard } from "lucide-react";
import type { PlanId } from "../lib/subscription";

interface PlanBadgeProps {
  planId: PlanId;
  isActive: boolean;
  loading?: boolean;
}

const CONFIG: Record<string, { label: string; color: string; bg: string; Icon: React.ComponentType<{ size?: number }> }> = {
  none: { label: "Sin plan", color: "#6b7280", bg: "rgba(107,114,128,0.12)", Icon: CreditCard },
  basic: { label: "Independiente", color: "#3b82f6", bg: "rgba(59,130,246,0.12)", Icon: Zap },
  equipo: { label: "Equipo", color: "#C9A14E", bg: "rgba(201,161,78,0.12)", Icon: Star },
  pro: { label: "Pro", color: "#C9A14E", bg: "rgba(201,161,78,0.12)", Icon: Star },
  enterprise: { label: "Empresarial", color: "#d97706", bg: "rgba(217,119,6,0.12)", Icon: Building2 },
};

export function PlanBadge({ planId, isActive, loading }: PlanBadgeProps) {
  if (loading) return null;

  // Fallback defensivo: si planId es undefined/null o no está en CONFIG, mostrar "Sin plan"
  const key = (isActive && planId && CONFIG[planId]) ? planId : "none";
  const cfg = CONFIG[key];
  const { label, color, bg, Icon } = cfg;

  return (
    <Link
      to="/precios"
      style={{
        display: "flex",
        alignItems: "center",
        gap: "0.4rem",
        padding: "0.3rem 0.6rem",
        borderRadius: "var(--radius-sm, 6px)",
        background: bg,
        color,
        fontSize: "0.75rem",
        fontWeight: 700,
        textDecoration: "none",
        transition: "opacity 0.2s",
        border: `1px solid ${color}30`,
      }}
    >
      <Icon size={13} />
      {label}
    </Link>
  );
}
